// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import App from './App';

import router from './router';
import ElementUI from 'element-ui';
import '../node_modules/element-ui/lib/theme-chalk/index.css';	//�ֶ����
import Public_components from '@/components/index';
import axios from 'axios';
import { copyFile } from 'fs';
import store from "./store";
import './styles/common.scss'
import * as filters from './filters' // global filters
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css';
import './icons'
import baseMixin from '@/components/Mixin/base';
import './directive';
import './utils/collectUtil'
import preventClick from './utils/clickStatefrom'  // 防止重复点击按钮
import inputTrim from './utils/inputTrim'  // 输入框失焦去除首尾空格

import vueSwiper from 'vue-awesome-swiper'  //引入vue-awesome-swiper
import 'swiper/dist/css/swiper.css'  //引入样式
import 'animate.css'



Vue.use(vueSwiper)  //使用插件

import IdleVue from "idle-vue";

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 10*60*1000,
  startAtIdle: false
});
// 修改 el-dialog 默认点击遮罩为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;
// MessageBox弹窗默认点击遮罩为不关闭 prompt,confirm
window.elPrompt=ElementUI.MessageBox.prompt;
ElementUI.MessageBox.prompt= function (){
  let options={};
  // debugger
  if(arguments.length==2){
    options=arguments[1];
  }else if(arguments.length==3){
    options=arguments[2];
  }
  if(! options.closeOnClickModal){
    options.closeOnClickModal=false;
  }
  return window.elPrompt(...arguments)
}
window.elConfirm=ElementUI.MessageBox.confirm;
ElementUI.MessageBox.confirm= function (){
  let options={};
  // debugger
  if(arguments.length==2){
    options=arguments[1];
  }else if(arguments.length==3){
    options=arguments[2];
  }
  if(! options.closeOnClickModal){
    options.closeOnClickModal=false;
  }
  return window.elConfirm(...arguments)
}


// axios.defaults.baseURL = "http://192.168.0.206:20030/sim" //gyh
// axios.defaults.baseURL = "http://192.168.0.163:20030/sim" //zc
//   axios.defaults.baseURL = 'http://192.168.0.162:20030/sim' //lzx
  // axios.defaults.baseURL ='http://fnjkj2.natapp4.cc/sim'  //内网穿透
 // axios.defaults.baseURL = 'http://fnjkjtest3.sim.fnjkj.cn:20030/sim' //测试
// axios.defaults.baseURL = 'http://192.168.0.108:20030/sim'  //wzc
 // axios.defaults.baseURL = 'http://192.168.0.247:20030/sim'  //zxs
//axios.defaults.baseURL = 'http://192.168.0.218:20030/sim'  //markup


axios.defaults.baseURL = 'https://sim.fnjkj.cn/sim' //生产环境
 //axios.defaults.baseURL = 'https://gray-sim.fnjkj.cn/sim' //灰度环境






Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(ElementUI);	//�ֶ����
Vue.use(Public_components);
Vue.use(Viewer);
Vue.mixin(baseMixin);
Vue.use(preventClick)
Vue.use(inputTrim)



Vue.prototype.$message = function(msg){
  // ElementUI.Message(msg)
  ElementUI.Message({...msg,showClose:true,offset:200,})
}
const messageArr = ['success', 'warning', 'info', 'error']
messageArr.forEach(function (type) {
  let configDet = {
      showClose: true,
      offset:200
  }
  Vue.prototype.$message[type] = function (message) {
      return ElementUI.Message[type]({
          message,
          ...configDet
      });
  }
})
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});
Viewer.setDefaults({
  Options: {
    "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true,
    "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true,
    "transition": true, "fullscreen": false, "keyboard": true, "url": "data-source"
  }
});
axios.interceptors.request.use(function (config) {
  let token = sessionStorage.getItem("token")
  config.headers['access-token'] = token
  // console.log(config)
  return config;
}, function (error) {
  return Promise.reject(error);
});
Vue.prototype.$axios = axios;
Vue.prototype.$EventBus = new Vue();
let theme=localStorage.getItem("theme")
if(!theme){
  theme="theme2";
}
window.document.documentElement.setAttribute('data-theme', theme);
store.dispatch('settings/changeSetting', {
  key: 'theme',
  value: theme
})
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})





// WEBPACK FOOTER //
// ./src/main.js